import { formatLanguageCode } from "@app/app/utils/languageDetector";
import { StripeElementLocale } from "@stripe/stripe-js";

const languageCodeMap: { [key: string]: StripeElementLocale | undefined } = {
    en: "en-GB",
    "en-US": "en-GB",
    nl: "nl",
    de: "de",
    fr: "fr",
    es: "es",
    it: "it",
    pt: "pt",
    zh: "zh", // Chinese
    tw: "zh-TW", // Taiwanese
    ar: "ar", // Arabic
    // cy: "cy", // Welsh: not supported by stripe
    vi: "vi", // Vietnamese
    vn: "vi", // Vietnamese
    bg: "bg",
    cs: "cs",
    da: "da",
    el: "el",
    "en-GB": "en-GB",
    "es-419": "es-419",
    et: "et",
    fi: "fi",
    fil: "fil",
    "fr-CA": "fr-CA",
    he: "he",
    hr: "hr",
    hu: "hu",
    id: "id",
    ja: "ja",
    ko: "ko",
    lt: "lt",
    lv: "lv",
    ms: "ms",
    mt: "mt",
    nb: "nb",
    pl: "pl",
    "pt-BR": "pt-BR",
    ro: "ro",
    ru: "ru",
    sk: "sk",
    sl: "sl",
    sv: "sv",
    th: "th",
    tr: "tr",
    "zh-HK": "zh-HK",
    "zh-TW": "zh-TW",
};

/**
 * Get the Stripe language code by our language code
 * @param languageCode
 * @returns
 */
export const mapLanguageCode = (languageCode: keyof typeof languageCodeMap): StripeElementLocale | undefined => {
    const formattedLanguageCode = formatLanguageCode(String(languageCode));
    const locale = new Intl.Locale(formattedLanguageCode);

    if (formattedLanguageCode in languageCodeMap) {
        return languageCodeMap[formattedLanguageCode];
    } else if (locale.language in languageCodeMap) {
        return languageCodeMap[locale.language];
    }

    return undefined;
};

/**
 * List with Stripe params which could be appended to the return URL
 */
export const stripeCheckoutReturnParams = [
    "payment_intent",
    "payment_intent_client_secret",
    "setup_intent",
    "setup_intent_client_secret",
    "redirect_status",
];
